import { createGlobalStyle } from 'styled-components'
import bodyBackground from '../assets/body-background.png'
import { Media } from '../styles'

export const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
  }

  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }

  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
    display: block;
  }

  body {
    line-height: 1;
    -webkit-font-smoothing: antialiased;
-moz-osx-font-smoothing: grayscale;
font-smooth: never;
  }

  ol, ul {
    list-style: none;
  }

  blockquote, q {
    quotes: none;
  }

  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }

  a {
    text-decoration: none;
  }

  body, html {
    margin: 0;
    width: 100%;
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    background-size: cover;
    color: #FFFFFF;
    scroll-behavior: smooth;
    overscroll-behavior-y: none;
  }

  body {
    padding: 24px 0 113px;
    min-height: 100vh;
    background-image: url(${bodyBackground}), linear-gradient(180deg, #000E47, #0A0E27 calc(100% - 104px));
    background-color: #0A0E27;
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-position: center top;

    ${Media.smallDesktop} {
      padding: 12px 16px 64px;
    }
  }

  button {
    border: none;
    background: none;
    font-family: 'Inter', sans-serif;
    cursor: pointer;
  }
`